var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 180,
    viewBox: "0 0 348 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1392_271916)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip1_1392_271916)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip2_1392_271916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.189 23.2949H300.719C287.33 23.2949 276.475 30.8248 276.475 40.1475C276.475 49.4523 265.623 57.0001 252.23 57.0001H210.869",
    stroke: "url(#paint0_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 29.4062H300.719C287.33 29.4062 276.474 36.9541 276.474 46.2588C276.474 55.5815 265.623 63.1114 252.23 63.1114H210.868",
    stroke: "url(#paint1_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 35.543H300.719C287.33 35.543 276.474 43.0728 276.474 52.3955C276.474 61.7183 265.623 69.2481 252.23 69.2481H210.868",
    stroke: "url(#paint2_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 41.6738H300.719C287.33 41.6738 276.474 49.2037 276.474 58.5264C276.474 67.8491 265.623 75.379 252.23 75.379H210.868",
    stroke: "url(#paint3_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 47.8086H300.719C287.33 47.8086 276.474 55.3385 276.474 64.6612C276.474 73.9839 265.623 81.5137 252.23 81.5137H210.868",
    stroke: "url(#paint4_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 53.9414H300.719C287.33 53.9414 276.474 61.4713 276.474 70.794C276.474 80.1167 265.623 87.6466 252.23 87.6466H210.868",
    stroke: "url(#paint5_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 60.0762H300.719C287.33 60.0762 276.474 67.606 276.474 76.9287C276.474 86.2515 265.623 93.7813 252.23 93.7813H210.868",
    stroke: "url(#paint6_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 66.209H300.719C287.33 66.209 276.474 73.7568 276.474 83.0616C276.474 92.3843 265.623 99.9141 252.23 99.9141H210.868",
    stroke: "url(#paint7_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 72.3438H300.719C287.33 72.3438 276.474 79.8736 276.474 89.1963C276.474 98.519 265.623 106.049 252.23 106.049H210.868",
    stroke: "url(#paint8_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 78.4746H300.719C287.33 78.4746 276.474 86.0224 276.474 95.3272C276.474 104.65 265.623 112.18 252.23 112.18H210.868",
    stroke: "url(#paint9_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 84.6094H300.719C287.33 84.6094 276.474 92.1393 276.474 101.462C276.474 110.785 265.623 118.315 252.23 118.315H210.868",
    stroke: "url(#paint10_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 90.7402H300.719C287.33 90.7402 276.474 98.2701 276.474 107.593C276.474 116.916 265.623 124.445 252.23 124.445H210.868",
    stroke: "url(#paint11_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.189 96.875H300.719C287.33 96.875 276.474 104.405 276.474 113.728C276.474 123.05 265.623 130.58 252.23 130.58H210.868",
    stroke: "url(#paint12_linear_1392_271916)",
    strokeWidth: 0.818753,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 306.253,
    cy: 53.9972,
    r: 3.68439,
    transform: "rotate(-180 306.253 53.9972)",
    fill: "url(#paint13_linear_1392_271916)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter1_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.256,
    cy: 69.1453,
    r: 2.45626,
    transform: "rotate(-180 245.256 69.1453)",
    fill: "url(#paint14_linear_1392_271916)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter2_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 317.306,
    cy: 96.9812,
    r: 2.45626,
    transform: "rotate(-180 317.306 96.9812)",
    fill: "url(#paint15_linear_1392_271916)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter3_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.151,
    y: 86.9512,
    width: 8.68411,
    height: 8.68411,
    rx: 0.818753,
    transform: "rotate(45 258.151 86.9512)",
    fill: "url(#paint16_linear_1392_271916)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter4_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.832 81.9117L288.676 69.9644L298.949 76.0736L288.832 81.9117Z",
    fill: "url(#paint17_linear_1392_271916)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.099,
    y: 16.6836,
    width: 97.4269,
    height: 97.4269,
    transform: "rotate(45 104.099 16.6836)",
    fill: "url(#paint18_linear_1392_271916)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M324.978 61.3929C321.911 61.3929 318.874 60.7888 316.04 59.615C313.207 58.4413 310.632 56.7209 308.463 54.5521C306.294 52.3834 304.574 49.8086 303.4 46.975C302.226 44.1413 301.622 41.1042 301.622 38.0371L324.978 38.0371L324.978 61.3929Z",
    fill: "url(#paint19_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.965,
    cy: 50.716,
    r: 6.67308,
    fill: "#353558"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M284.94 159.486C284.94 155.542 284.163 151.638 282.654 147.994C281.145 144.351 278.933 141.041 276.144 138.252C273.356 135.464 270.045 133.252 266.402 131.743C262.759 130.234 258.854 129.457 254.911 129.457C250.967 129.457 247.062 130.234 243.419 131.743C239.776 133.252 236.466 135.464 233.677 138.252C230.889 141.041 228.677 144.351 227.168 147.994C225.659 151.638 224.882 155.542 224.882 159.486L254.911 159.486H284.94Z",
    fill: "url(#paint20_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M20.0185 111.439V141.468H50.0474L20.0185 111.439Z",
    fill: "url(#paint21_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.6665 78.0007C84.4294 78.0007 88.1555 77.2592 91.632 75.8185C95.1085 74.3779 98.2673 72.2663 100.928 69.6044C103.589 66.9424 105.7 63.7822 107.14 60.3042C108.58 56.8262 109.321 53.0985 109.321 49.334L80.6665 49.334L80.6665 78.0007Z",
    fill: "url(#paint22_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1392_271916)",
    filter: "url(#filter5_bdi_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.3942,
    height: 40.7058,
    transform: "translate(29.3608 97.4277)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6992,
    y: 102.766,
    width: 16.0154,
    height: 16.0154,
    rx: 8.00769,
    fill: "url(#paint23_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0819 122.785H34.6992V126.789H86.0819V122.785ZM79.4088 128.791H34.6992V132.795H79.4088V128.791Z",
    fill: "url(#paint24_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter6_f_1392_271916)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 20.3529,
    transform: "matrix(1 0 0 -1 33.6981 129.792)",
    fill: "#0061FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter7_f_1392_271916)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.3529,
    ry: 16.0154,
    transform: "matrix(1 0 0 -1 93.0887 134.129)",
    fill: "#06D8DD"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_bdi_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 30,
    width: 120.115,
    height: 120.115,
    rx: 29.4548,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 30,
    width: 120.115,
    height: 120.115,
    rx: 29.4548,
    fill: "url(#paint25_radial_1392_271916)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 30,
    width: 120.115,
    height: 120.115,
    rx: 29.4548,
    fill: "url(#paint26_radial_1392_271916)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.681,
    y: 44.6816,
    width: 90.7539,
    height: 90.7539,
    rx: 16.0154,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 144.696,
    y: 76.0449,
    width: 63.3942,
    height: 42.7077,
    rx: 2.44341,
    fill: "url(#paint27_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter9_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.4,
    y: 76.0449,
    width: 24.6904,
    height: 42.7077,
    rx: 1.14847,
    fill: "url(#paint28_linear_1392_271916)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter10_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.357,
    y: 63.3652,
    width: 63.3942,
    height: 16.0154,
    rx: 2.66923,
    fill: "url(#paint29_linear_1392_271916)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter11_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.038,
    y: 58.6953,
    width: 3.33654,
    height: 10.0096,
    rx: 1.14847,
    fill: "url(#paint30_linear_1392_271916)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter12_d_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.734,
    y: 58.6953,
    width: 3.33654,
    height: 10.0096,
    rx: 1.14847,
    fill: "url(#paint31_linear_1392_271916)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_bdi_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.333,
    y: 105.332,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.333,
    y: 105.332,
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint32_radial_1392_271916)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.333,
    y: 105.332,
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint33_radial_1392_271916)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_bdi_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.333,
    y: 105.332,
    width: 50.1569,
    height: 50.1569,
    rx: 25.0784,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.333,
    y: 105.332,
    width: 50.1569,
    height: 50.1569,
    rx: 25.0784,
    fill: "url(#paint34_radial_1392_271916)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.333,
    y: 105.332,
    width: 50.1569,
    height: 50.1569,
    rx: 25.0784,
    fill: "url(#paint35_radial_1392_271916)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.006,
    y: 112.006,
    width: 36.7019,
    height: 36.7019,
    rx: 18.351,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 10.9025,
    height: 4.74239,
    transform: "matrix(0.708944 0.705265 -0.708944 0.705265 214.929 129.889)",
    fill: "url(#paint36_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 25.2138,
    height: 4.74239,
    transform: "matrix(0.708944 -0.705265 0.708944 0.705265 215.91 137.574)",
    fill: "url(#paint37_linear_1392_271916)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_bdi_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.333,
    y: 25.332,
    width: 38.788,
    height: 38.788,
    rx: 19.394,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.333,
    y: 25.332,
    width: 38.788,
    height: 38.788,
    rx: 19.394,
    fill: "url(#paint38_radial_1392_271916)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.333,
    y: 25.332,
    width: 38.788,
    height: 38.788,
    rx: 19.394,
    fill: "url(#paint39_radial_1392_271916)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.4375,
    y: 30.4375,
    width: 28.5806,
    height: 28.5806,
    rx: 14.2903,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 107.237,
    cy: 56.4651,
    r: 9.697,
    transform: "rotate(-90 107.237 56.4651)",
    fill: "url(#paint40_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 106.49,
    cy: 44.4889,
    r: 7.14516,
    fill: "url(#paint41_linear_1392_271916)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_bdi_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.333,
    y: 53,
    width: 26.0816,
    height: 26.0816,
    rx: 13.0408,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.333,
    y: 53,
    width: 26.0816,
    height: 26.0816,
    rx: 13.0408,
    fill: "url(#paint42_radial_1392_271916)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.333,
    y: 53,
    width: 26.0816,
    height: 26.0816,
    rx: 13.0408,
    fill: "url(#paint43_radial_1392_271916)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1392_271916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.7656,
    y: 56.4316,
    width: 19.218,
    height: 19.218,
    rx: 9.609,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 54.7167,
    cy: 73.9327,
    r: 6.52039,
    transform: "rotate(-90 54.7167 73.9327)",
    fill: "url(#paint44_linear_1392_271916)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 54.3743,
    cy: 64.6678,
    r: 4.8045,
    fill: "url(#paint45_linear_1392_271916)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1392_271916",
    x: 297.119,
    y: 47.8905,
    width: 17.0568,
    height: 17.0573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.605512,
    dy: 2.42205
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42205
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1392_271916",
    x: 237.35,
    y: 64.2674,
    width: 14.6008,
    height: 14.6003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.605512,
    dy: 2.42205
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42205
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176569 0 0 0 0 0.123424 0 0 0 0 0.78774 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1392_271916",
    x: 309.4,
    y: 92.1033,
    width: 14.6008,
    height: 14.6003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.605512,
    dy: 2.42205
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42205
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1392_271916",
    x: 246.9,
    y: 84.869,
    width: 21.2907,
    height: 21.2897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.605512,
    dy: 2.42205
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42205
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1392_271916",
    x: 283.226,
    y: 67.5428,
    width: 19.9611,
    height: 21.6355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.605512,
    dy: 2.42205
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42205
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176569 0 0 0 0 0.123424 0 0 0 0 0.78774 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bdi_1392_271916",
    x: 26.6916,
    y: 94.7585,
    width: 72.3824,
    height: 50.0094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.33462
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1392_271916"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.89573,
    dy: 2.21169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.21169
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1392_271916",
    result: "effect2_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1392_271916",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.851626,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.667308,
    dy: -0.667308
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1392_271916"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1392_271916",
    x: -4.67209,
    y: 91.4221,
    width: 76.7402,
    height: 76.7397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.00865,
    result: "effect1_foregroundBlur_1392_271916"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1392_271916",
    x: 60.7243,
    y: 106.102,
    width: 64.7286,
    height: 56.0543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.00577,
    result: "effect1_foregroundBlur_1392_271916"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_bdi_1392_271916",
    x: 95.6337,
    y: 13.9299,
    width: 184.396,
    height: 184.396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4.59145
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1392_271916"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13.7744,
    dy: 16.0701
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.0701
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1392_271916",
    result: "effect2_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1392_271916",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.573932,
    dy: -2.29573
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1392_271916"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1392_271916",
    x: 178.232,
    y: 73.748,
    width: 33.8782,
    height: 51.8948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.574237,
    dy: 2.29695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1392_271916",
    x: 125.919,
    y: 56.035,
    width: 87.8281,
    height: 40.4497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.22171,
    dy: 4.88682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.10852
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.123424 0 0 0 0 0.429009 0 0 0 0 0.78774 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1392_271916",
    x: 148.87,
    y: 56.3984,
    width: 12.5242,
    height: 19.1976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.574237,
    dy: 2.29695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176569 0 0 0 0 0.123424 0 0 0 0 0.78774 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1392_271916",
    x: 179.566,
    y: 56.3984,
    width: 12.5242,
    height: 19.1976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.574237,
    dy: 2.29695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176569 0 0 0 0 0.123424 0 0 0 0 0.78774 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1392_271916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_bdi_1392_271916",
    x: 193.088,
    y: 99.8674,
    width: 72.0153,
    height: 72.0149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.56133
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1392_271916"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.68399,
    dy: 5.46465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.46465
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1392_271916",
    result: "effect2_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1392_271916",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.996294,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.780665,
    dy: -0.780665
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1392_271916"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_bdi_1392_271916",
    x: 191.829,
    y: 98.7658,
    width: 76.4218,
    height: 76.4213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.87607
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1392_271916"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.62822,
    dy: 6.56626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.56626
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1392_271916",
    result: "effect2_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1392_271916",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.234509,
    dy: -0.938037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1392_271916"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_bdi_1392_271916",
    x: 81.4225,
    y: 20.1603,
    width: 59.475,
    height: 59.474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.47764
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1392_271916"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.43291,
    dy: 5.17173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.17173
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1392_271916",
    result: "effect2_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1392_271916",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.184705,
    dy: -0.738819
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1392_271916"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_bdi_1392_271916",
    x: 37.3587,
    y: 49.5225,
    width: 39.9917,
    height: 39.9922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 0.993584
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1392_271916"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.98075,
    dy: 3.47754
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.47754
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.380392 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1392_271916",
    result: "effect2_dropShadow_1392_271916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1392_271916",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.124198,
    dy: -0.496792
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1392_271916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_271916",
    x1: 361.045,
    y1: -26.6832,
    x2: 249.297,
    y2: 92.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1392_271916",
    x1: 361.044,
    y1: -20.5719,
    x2: 249.297,
    y2: 98.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1392_271916",
    x1: 361.044,
    y1: -14.4351,
    x2: 249.297,
    y2: 105.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1392_271916",
    x1: 361.044,
    y1: -8.30427,
    x2: 249.297,
    y2: 111.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1392_271916",
    x1: 361.044,
    y1: -2.1695,
    x2: 249.297,
    y2: 117.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1392_271916",
    x1: 361.044,
    y1: 3.96331,
    x2: 249.297,
    y2: 123.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1392_271916",
    x1: 361.044,
    y1: 10.0981,
    x2: 249.297,
    y2: 129.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1392_271916",
    x1: 361.044,
    y1: 16.2309,
    x2: 249.297,
    y2: 135.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1392_271916",
    x1: 361.044,
    y1: 22.3657,
    x2: 249.297,
    y2: 141.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1392_271916",
    x1: 361.044,
    y1: 28.4965,
    x2: 249.297,
    y2: 147.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1392_271916",
    x1: 361.044,
    y1: 34.6313,
    x2: 249.297,
    y2: 154.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1392_271916",
    x1: 361.044,
    y1: 40.7621,
    x2: 249.297,
    y2: 160.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1392_271916",
    x1: 361.044,
    y1: 46.8969,
    x2: 249.297,
    y2: 166.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1392_271916",
    x1: 302.542,
    y1: 51.7951,
    x2: 309.928,
    y2: 59.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1392_271916",
    x1: 247.685,
    y1: 71.6016,
    x2: 240.001,
    y2: 69.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1392_271916",
    x1: 319.735,
    y1: 99.4375,
    x2: 312.051,
    y2: 96.9802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1392_271916",
    x1: 266.787,
    y1: 95.6353,
    x2: 253.203,
    y2: 91.2914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1392_271916",
    x1: 299.772,
    y1: 73.0025,
    x2: 289.562,
    y2: 88.8928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1392_271916",
    x1: 191.976,
    y1: 86.9159,
    x2: 88.3667,
    y2: 32.7514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D8DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1392_271916",
    x1: 359.61,
    y1: 30.7119,
    x2: 345.586,
    y2: 75.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1392_271916",
    x1: 284.606,
    y1: 159.486,
    x2: 211.116,
    y2: 112.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1392_271916",
    x1: 50.0474,
    y1: 91.6477,
    x2: 20.0185,
    y2: 141.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1392_271916",
    x1: 38.178,
    y1: 40.3431,
    x2: 55.3971,
    y2: 94.9548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1392_271916",
    x1: 50.6256,
    y1: 118.781,
    x2: 25.574,
    y2: 110.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1392_271916",
    x1: 85.7965,
    y1: 132.795,
    x2: 61.8183,
    y2: 93.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8659 185.223) rotate(-34.528) scale(165.273 286.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D8DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(274.669 176.508) rotate(-133.295) scale(129.457 224.234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1392_271916",
    x1: 144.696,
    y1: 47.8967,
    x2: 178.368,
    y2: 130.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1392_271916",
    x1: 207.953,
    y1: 118.753,
    x2: 166.789,
    y2: 111.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1392_271916",
    x1: 139.13,
    y1: 66.5867,
    x2: 146.358,
    y2: 97.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1392_271916",
    x1: 157.356,
    y1: 68.7049,
    x2: 151.668,
    y2: 68.0986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1392_271916",
    x1: 188.052,
    y1: 68.7049,
    x2: 182.364,
    y2: 68.0986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.565 169.946) rotate(-34.528) scale(68.7977 119.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D8DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.215 166.319) rotate(-133.295) scale(53.8888 93.341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.443 170.149) rotate(-34.528) scale(69.0135 119.539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D8DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.424 166.51) rotate(-133.295) scale(54.0578 93.6339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1392_271916",
    x1: -0.0391554,
    y1: 0.953929,
    x2: 3.29662,
    y2: 9.11481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1392_271916",
    x1: -7.90797,
    y1: -7.03203,
    x2: 5.96107,
    y2: 16.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2581 75.4569) rotate(-34.528) scale(53.3705 92.4433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D8DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.217 72.6429) rotate(-133.295) scale(41.8047 72.4102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1392_271916",
    x1: 116.826,
    y1: 66.1621,
    x2: 86.4898,
    y2: 56.4609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1392_271916",
    x1: 94.8628,
    y1: 16.154,
    x2: 122.089,
    y2: 24.7347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1102 86.7047) rotate(-34.528) scale(35.887 62.1601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D8DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_1392_271916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.2203 84.8125) rotate(-133.295) scale(28.1101 48.6896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1392_271916",
    x1: 44.1062,
    y1: 48.0754,
    x2: 68.9517,
    y2: 55.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1392_271916",
    x1: 59.1254,
    y1: 69.4723,
    x2: 44.0948,
    y2: 64.6657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1392_271916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 346.667,
    height: 180,
    fill: "white",
    transform: "translate(0.666504)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1392_271916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.001,
    height: 115.444,
    fill: "white",
    transform: "translate(341.869 135.463) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1392_271916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130.696,
    height: 107.286,
    fill: "white",
    transform: "matrix(-1 0 0 1 341.564 23.2949)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1392_271916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.3942,
    height: 40.7058,
    fill: "white",
    transform: "translate(29.3608 97.4277)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1392_271916"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.681,
    y: 44.6816,
    width: 90.7539,
    height: 90.7539,
    rx: 16.0154,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1392_271916"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.4375,
    y: 30.4375,
    width: 28.5806,
    height: 28.5806,
    rx: 14.2903,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1392_271916"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.7656,
    y: 56.4316,
    width: 19.218,
    height: 19.218,
    rx: 9.609,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingConfirmed);
export default __webpack_public_path__ + "static/media/meetingConfirmed.3eeadf1e.svg";
export { ForwardRef as ReactComponent };